import styled, { keyframes } from "styled-components";

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-weight: 300;
    width: ${props => props.selected ? 300 : 280}px;
    min-width: ${props => props.selected ? 330 : 280}px;
    height: ${props => props.selected ? 190 : 160}px;
    padding: ${props => props.selected ? '22px 34px' : '16px 24px'}  ;
    margin-right: 16px;
    border-radius: 12px;
    color: ${props => props.theme.colors.textBold};
    background-color: ${props => props.selected ? props.theme.colors.primary + '05' : 'white'};
    border: ${props => props.selected ? 2 : 1}px solid ${props => props.selected ? props.theme.colors.primary : '#E2E2E2'}
    cursor: pointer;
    box-shadow: 6px 6px 10px #00000008;
    transition:  all 0.3s ease-out;
    position: relative;
    overflow: hidden;

    & .wrapper {
        width: ${props => props.selected ? '100%' : '0px'};
        height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 5px;
        background: ${props => `linear-gradient(90deg, ${props.theme.colors.primary}08,  ${props.theme.colors.primary}01);`}; 
        overflow: hidden;
      }
      
      & .wave {
        width: 200%;
        height: 260%;    
        position: absolute;
        top: 46%;
        left: -5%;
        margin-left: -50px;
        margin-top: 0px;
        border-radius: 35%;
        background: ${props => props.theme.colors.primary}08;
        transform: rotate(326deg);
      }
`;

export const CardBody = styled.div`
    z-index: 16;
`;

export const CardItem = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    z-index: 10;
`;

export const CardFooter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 11;
`;

export const CardPoints = styled.div`
    font-size: ${props => props.selected ? '22px' : '18px'};
    font-weight: 500;
    line-height: 1;
    color: ${props => props.theme.colors.primary}
    z-index: 12;
`;
